export const updateNewCandidate = 'updateNewCandidate';
export const updateIsAddCandidateClicked = 'updateIsAddCandidateClicked';
export const updateCandidates = "updateCandidates";
export const updateIsEditCandidateClicked = "updateIsEditCandidateClicked";
export const updateCandidatesDataTable = "updateCandidatesDataTable";
export const updateIsViewCandidateClicked = "updateIsViewCandidateClicked";
export const updateNewCandidateInterview = 'updateNewCandidateInterview';
export const updateInterview = 'updateInterview';
export const updateInterviewDataTable = 'updateInterviewDataTable'